import { atom } from 'jotai';

export const change_active_tab_index_atom = atom<number | null>(null);

export const shop_bookmark_atom = atom<boolean>(false);

export const change_shop_bookmark_atom = atom<boolean>(false);

// MEMO: 뉴티아라 로그에 필요한 값으로 pdp depth가 깊어 atom으로 관리
export const userUUIDAtom = atom<string>('');
export const is_ended_preorder_atom = atom<boolean>(false);

export const productDetailVisibleAtom = atom<boolean>(false);

// MEMO: 뷰티 성분탭 > 성분 아이템 활성화 인덱스
export const beauty_active_ingredient_item_idx_atom = atom({ primary: -1, warning: -1 });

// MEMO: Tab stickyRef
export const stickyTabRefAtom = atom<{ current: HTMLElement | null }>({ current: null });

export const showBottomZigzinBannerAtom = atom<boolean>(false);

// MEMO: ATF 사이즈 아이콘에서 탭 툴팁을 숨기기 위한 콜백 공유용 atom
export const hideSizeTabTooltipAtom = atom<(() => void) | null>(null);

// MEMO: 프로모션 배너가 뷰포트에 보이는지 여부 (false = 뷰포트 밖 = 플로팅 배너 표시)
export const isPromotionBannerInViewAtom = atom<boolean>(true);
